<ng-container *ngIf="data.length; else emptyTmpl">
  <p500-ui-many-items [data]="data" [tmpl]="tmpl" [previewTmpl]="previewTmpl" [buttonTmpl]="buttonTmpl" popupClass="c-many-data-popup">
  </p500-ui-many-items>
  <ng-template #previewTmpl> </ng-template>
  <ng-template let-item="data" #tmpl>
    <div class="c-many-data">
      <div class="c-many-data__item">
        <div class="c-many-data__item -title">Baseline:&nbsp;</div>
        <gtd-ui-field-default-string-whitespace-or-empty [data]="globalData.baseline_fields[item?.baseline_field] || item?.baseline_field">
        </gtd-ui-field-default-string-whitespace-or-empty>
      </div>
      <div class="c-many-data__item">
        <div class="c-many-data__item -title">Goal Type:&nbsp;</div>
        <gtd-ui-field-default-string-whitespace-or-empty [data]="globalData.goal_types[item?.goal_type_id] || item?.goal_type_id">
        </gtd-ui-field-default-string-whitespace-or-empty>
      </div>
    </div>
  </ng-template>
  <ng-template let-open="open" #buttonTmpl>
    <div class="c-field-value c-field-value--view-mode d-flex">
      <span class="c-field-value__icon" (click)="open($event)">
        <p500-ui-icon name="eye"></p500-ui-icon>
      </span>
      <span>Show</span>
    </div>
  </ng-template>
</ng-container>

<ng-template #emptyTmpl>
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-template>
